import { render, staticRenderFns } from "./PackagesDataViewSidebar.vue?vue&type=template&id=3cd937f4&scoped=true&"
import script from "./PackagesDataViewSidebar.vue?vue&type=script&lang=js&"
export * from "./PackagesDataViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PackagesDataViewSidebar.vue?vue&type=style&index=0&id=3cd937f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd937f4",
  null
  
)

export default component.exports